import { getType } from 'deox';
import { resetActions } from '../actions';

export type SuccessState = { [id: string]: boolean };

interface SuccessAction {
  type: string;
  payload?: string;
}

interface ResetAction {
  type: string;
  payload: {
    actionName: string;
  };
}

const successReducer = (
  state: SuccessState = {},
  action: SuccessAction | ResetAction,
): SuccessState => {
  if (action.type === getType(resetActions.reset)) {
    const { actionName } = (action as ResetAction).payload;
    const { [actionName]: _, ...newState } = state;
    return newState;
  }

  const matches = /(.*)_(REQUEST|SUCCESS)/.exec(action.type);

  if (!matches) return state;

  const [, requestName, requestStatus] = matches;
  return {
    ...state,
    [requestName]: requestStatus === 'SUCCESS',
  };
};

export default successReducer;
